import { Vue, Component, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import MCIcon from '@/components/icons/mc-icon/mc-icon';
import { sessionService } from '@/providers/services/auth/session';
import { USER_TYPE, SUPER_ADMIN_TENANT } from '@/utils/constants';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import axios from 'axios';
import { isAPICatchError, isEmptyValue, sortByPropertyLowerCase } from '@/utils/utils';
import DropdownSelectCheck from '@/components/dropdown-select-check/dropdown-select-check';
import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';

@Component({
    name: 'setup',
    components: {
        'material-icons': GoogleMaterialIcon,
        'mc-icons': MCIcon,
        'sso-setup': () => import('./sso-setup/sso-setup'),
        'dropdown-select-check': DropdownSelectCheck,
    },
})

export default class Setup extends Vue {

    // -----------------------------------------------------------------
    // Properties

    public get session() {
        return sessionService.getSession();
    }

    public get activeTenantId() {
        return this.$access.getTenantId();
    }

    public get userType() {
        return this.$access.getUserType();
    }

    public get filteredTenantList() {
        return this.tenantList.filter((item: any) => {
            return item.name.toLowerCase().indexOf(this.tenantSearchText.toLowerCase()) > -1;
        });
    }

    public tenantList: any = [];

    public selectedTenant: any = [];

    public tenantSearchText: string = '';

    public adminTenant: string = SUPER_ADMIN_TENANT;

    public menuFilter: any = [];

    public userTypeList: any = USER_TYPE;

    public setupMenu: any = [
        {
            route: '/setup/view',
            icon: 'dashboard_customize',
            label: 'Settings',
            name: 'settings',
            active: true,
        },
        // {
        //     route: '/setup/sso-setup',
        //     icon: 'settings',
        //     label: 'SSO',
        //     name: 'sso',
        // },
        {
            route: '/setup/subjects-facets',
            icon: 'school',
            label: 'Subjects/Frameworks',
            name: 'subjectsFrameworks',
            active: this.userType === this.userTypeList.superUser && this.adminTenant === this.activeTenantId,
        },
        {
            route: '/setup/tenant-settings',
            icon: 'class',
            label: 'Class Settings',
            queryParams: { activeSettings: 'classSettings' },
            name: 'classSettings',
            active: true,
        },
        {
            route: '/setup/class-configuration',
            icon: 'auto_stories',
            label: 'Default class setup',
            name: 'classConfiguration',
            active: true,
        },
        {
            route: '/setup/tenant-settings',
            icon: 'security',
            label: 'Privacy',
            queryParams: { activeSettings: 'privacy' },
            name: 'privacy',
            active: true,

        },
        {
            route: '/setup/tenant-settings',
            icon: 'library_books',
            label: 'Roster',
            queryParams: { activeSettings: 'roster' },
            name: 'roster',
            active: true,
        },
        {
            route: '/setup/tenant-settings',
            icon: 'military_tech',
            label: 'Mastery',
            queryParams: { activeSettings: 'mastery' },
            name: 'mastery',
            active: true,
        },
        {
            route: '/setup/tenant-settings',
            icon: 'explore',
            label: 'Initial Skyline Config',
            queryParams: { activeSettings: 'locatingLearner' },
            name: 'locatingLearner',
            active: true,
        },
        {
            route: '/setup/tenant-settings',
            icon: 'summarize',
            label: 'Reports',
            queryParams: { activeSettings: 'reports' },
            name: 'reports',
            active: true,
        },
        {
            route: '/setup/tenant-settings',
            icon: 'local_library',
            label: 'Study',
            queryParams: { activeSettings: 'study' },
            name: 'study',
            active: true,
        },
        {
            route: '/setup/tenant-settings',
            icon: 'map',
            label: 'Learning Journey',
            queryParams: { activeSettings: 'learningJourney' },
            name: 'learningJourney',
            active: true,
        },
        {
            route: '/setup/lor-facets',
            icon: 'fact_check',
            label: 'Facets Settings',
            name: 'lorFacets',
            active: true,
        },
        {
            route: '/setup/tenant-settings',
            icon: 'phone_iphone',
            label: 'Mobile App',
            queryParams: { activeSettings: 'mobileApp' },
            name: 'mobileApp',
            active: true,
        },
        {
            route: '/setup/tenant-settings',
            icon: 'content_copy',
            label: 'Content Types',
            queryParams: { activeSettings: 'contentTypes' },
            name: 'contentTypes',
            active: true,
        },
        {
            route: '/setup/tenant-settings',
            icon: 'admin_panel_settings',
            label: 'Admin',
            queryParams: { activeSettings: 'admin' },
            name: 'admin',
            active: true,
        },
        {
            route: '/setup/tenant-settings',
            icon: 'settings_applications',
            label: 'General',
            queryParams: { activeSettings: 'general' },
            name: 'general',
            active: true,
        },
        {
            route: '/setup/tenant-settings',
            icon: 'corporate_fare',
            label: 'White Labeling',
            queryParams: { activeSettings: 'whiteLabeling' },
            name: 'whiteLabeling',
            active: true,
        },
        {
            route: '/setup/user-list',
            icon: 'group_add',
            label: 'Role & Permissions',
            // isDisable: true,
            name: 'rolePermissions',
            active: true,
        },
        {
            route: '/setup/translations-list',
            icon: 'translate',
            label: 'Translations',
            // isDisable: true,
            name: 'translations',
            active: true,
        },
    ];

    // Hook
    public created() {
        // this.userType = this.$access.getUserType();
        this.fetchMenuFilter();
        // this.fetchTenantList();
    }

    public mounted() {
        // this.userType = this.$access.getUserType();
        this.fetchMenuFilter();
        // this.fetchTenantList();
    }

    // ------------------------------------------------------------------
    // Actions
    public onSelectTenant(tenant: any) {
        const tenantDd = (this.$refs as any).tenantDd;
        if (tenantDd) {
            tenantDd.hide(true);
        }
        this.selectedTenant = tenant;
    }

    private toggleSubMenu(className: string) {
        const element: HTMLElement | any = this.$el.querySelector(`.${className}`);
        element.style.display = element.style.display === 'block' ? 'none' : 'block';
    }

    private fetchMenuFilter() {
        tenantSettingsAPI.fetcTenantConfigKeys().then((tenantConfigKey) => {
            const tenantConfigKeysList = tenantConfigKey;
            return Object.keys(tenantConfigKeysList);
        }).then((tenantConfigKeys) => {
            this.menuFilter = this.setupMenu.filter((menu: any) => {
                return tenantConfigKeys.some((keys: any) => {
                    return keys === menu.name || menu.name === 'whiteLabeling'
                        || menu.name === 'rolePermissions' || menu.name === 'settings'
                        || menu.name === 'translations' || menu.name === 'lorFacets';
                });
            });
        });
    }

    // private fetchTenantList() {
    //     const params = {
    //         offset: 0,
    //         limit: 500,
    //     };

    //     adminUtilsAPI.fetchTenantList(params).then((data: any) => {
    //         sortByPropertyLowerCase(data.list, 'name', 'ASC');
    //         this.tenantList = data.list;
    //         const tenantId = this.activeTenantId;
    //         const activeTenant = this.tenantList.filter((item: any) => item.id === tenantId);
    //         if (this.userType === this.userTypeList.superUser && this.adminTenant === this.activeTenantId) {
    //             this.selectedTenant  = activeTenant[0];
    //         }

    //     });
    // }
}
